<template>

  <!-- Main Container -->
  <div class="container-lg my-[3rem] ">
  
    <MainBannerSlider :main="gallery_banners" :extras="extra_banners" />

    <div class="mt-[1.5rem]">
      <!-- Benefits Section (Benefit Banners) -->
      <div class="col-lg-12">
        <benefits
            :benefit_banners="benefit_banners"
        /><!-- Component: Benefits Slider -->
      </div><!-- /.col -->

    </div><!-- /.row -->
  </div><!-- /.container -->

  <!-- Featured Products Slider -->
  <auto-slider
      :in18="in18"
      :type="'featured'"
  /><!-- Component: Auto Slider (Featured Products) -->

  <!-- Categories Section (Root Categories) -->
  <categories
      :in18="in18"
      :type="'root_categories'"
      :title="in18['page_main_categories']"
      :highlight_title="in18['page_main_categories_highlight']"
      :categories="root_categories"
  /><!-- Component: Categories (Main Categories) -->

  <!-- Featured Banners Section -->
  <featured
      :featured_banners="featured_banners"
  /><!-- Component: Featured Banners Slider -->

  <!-- New Products Slider -->
  <auto-slider
      :in18="in18"
      :type="'new'"
  /><!-- Component: Auto Slider (New Products) -->

  <!-- Discounted Products Slider -->
  <auto-slider
      :in18="in18"
      :type="'discount'"
  /><!-- Component: Auto Slider (Discounted Products) -->

  <!-- Categories Section (Featured Categories) -->
  <categories
      :in18="in18"
      :type="'featured_categories'"
      :title="in18['page_featured_categories']"
      :highlight_title="in18['page_featured_categories_highlight']"
      :categories="featured_categories"
  /><!-- Component: Categories (Featured Categories) -->

  <!-- Info Banner Section -->
  <info :in18="in18"
        :info_banner="info_banner"
  /><!-- Component: Info Banner -->

  <!-- Recommended Products Slider -->
  <auto-slider
      :in18="in18"
      :type="'popular'"
  /><!-- Component: Auto Slider (Recommended Products) -->

</template>

<script>

import Extras from "../components/banner/Extras.vue"
import Info from "../components/banner/Info.vue"
import Gallery from "../components/banner/Gallery.vue"
import Benefits from "../components/banner/Benefits.vue"
import Featured from "../components/banner/Featured.vue"
import InfoBlock from "../components/home/InfoBlock.vue"
import Categories from "../components/home/Categories.vue"
import MainBannerSlider from "../components/banner/MainBannerSlider.vue"

export default {
  name:       "Home",
  components: {
    Categories,
    Gallery,
    Benefits,
    InfoBlock,
    Extras,
    Featured,
    Info,
    MainBannerSlider
  },
  props:      [
    'in18',
    'root_categories',
    'gallery_banners',
    'benefit_banners',
    'extra_banners',
    'featured_banners',
    'info_banner',
    'featured_categories',
  ],
}
</script>